import { Route, Switch } from 'react-router-dom'
import React, { useState } from 'react'

import ProfileCreationConfirmationContainer from './ProfileCreationConfirmationContainer'
import ProfileCreationContainer from './ProfileCreationContainer'
import ProfileContainer from './ProfileContainer'
import ProfileView from './ProfileView'
import ProfileStatsView from './ProfileStatsView'

const ProfileRoutes = () => {
  const [editingEnabled, setEditingEnabled] = useState(false)

  return (
    <Route path="/profiles">
      <Switch>
        <Route path="/profiles/intake/">
          <Switch>
            <Route path="/profiles/intake/confirm" exact>
              <ProfileCreationConfirmationContainer />
            </Route>
            <Route path="/profiles/intake/:intakeFormId">
              <ProfileCreationContainer />
            </Route>
          </Switch>
        </Route>

        <Route path="/profiles/:profileType/:profileId">
          <ProfileContainer
            editingEnabled={editingEnabled}
            setEditingEnabled={setEditingEnabled}>
            <Switch>
              <Route path="/profiles/:profileType/:profileId" exact>
                <ProfileView
                  editingEnabled={editingEnabled}
                  setEditingEnabled={setEditingEnabled}
                />
              </Route>
              <Route path="/profiles/:profileType/:profileId/stats">
                <ProfileStatsView />
              </Route>
            </Switch>
          </ProfileContainer>
        </Route>
      </Switch>
    </Route>
  )
}

export default ProfileRoutes
